var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgQuestionmarkGrayscale(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "roper",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 541.87 544.29",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#202020;}.cls-2{fill:#747474;}.cls-3{fill:#4b4b4b;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "main"
  }, /*#__PURE__*/React.createElement("g", {
    id: "question-mark"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    className: "cls-1",
    cx: 278.05,
    cy: 144.54,
    r: 39.27
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    className: "cls-1",
    d: "M373.62,400.25A39.26,39.26,0,1,1,334.5,361,39.26,39.26,0,0,1,373.62,400.25Z",
    transform: "translate(-0.66 -0.01)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape1",
    className: "cls-1",
    d: "M294.35,423.7a39.26,39.26,0,1,1-11.47-27.79A39.27,39.27,0,0,1,294.35,423.7Z",
    transform: "translate(-0.66 -0.01)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval1",
    className: "cls-1",
    cx: 254.43,
    cy: 505.02,
    r: 39.27
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape2",
    className: "cls-2",
    d: "M324.35,34.42a18.63,18.63,0,1,1,6-25.52A18.64,18.64,0,0,1,324.35,34.42Z",
    transform: "translate(-0.66 -0.01)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape3",
    className: "cls-3",
    d: "M312,93.56A24.39,24.39,0,1,1,319.84,60,24.41,24.41,0,0,1,312,93.56Z",
    transform: "translate(-0.66 -0.01)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval2",
    className: "cls-1",
    cx: 385.3,
    cy: 337.86,
    r: 39.27
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape4",
    className: "cls-2",
    d: "M494.71,388.6a18.64,18.64,0,1,1,11.3,8.81A18.62,18.62,0,0,1,494.71,388.6Z",
    transform: "translate(-0.66 -0.01)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval3",
    className: "cls-3",
    cx: 458.15,
    cy: 362.82,
    r: 24.38
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval4",
    className: "cls-1",
    cx: 392.75,
    cy: 253.76,
    r: 39.27
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape5",
    className: "cls-2",
    d: "M513.45,251.19a18.63,18.63,0,1,1,25.85-4.94A18.65,18.65,0,0,1,513.45,251.19Z",
    transform: "translate(-0.66 -0.01)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval5",
    className: "cls-3",
    cx: 467.87,
    cy: 243.96,
    r: 24.38
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval6",
    className: "cls-1",
    cx: 351.97,
    cy: 180.8,
    r: 39.27
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape6",
    className: "cls-2",
    d: "M456.23,120.18a18.66,18.66,0,1,1,13.62-4.32A18.63,18.63,0,0,1,456.23,120.18Z",
    transform: "translate(-0.66 -0.01)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape7",
    className: "cls-3",
    d: "M411.61,159.87A24.38,24.38,0,1,1,438,137.76,24.39,24.39,0,0,1,411.61,159.87Z",
    transform: "translate(-0.66 -0.01)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval7",
    className: "cls-1",
    cx: 194.38,
    cy: 156.34,
    r: 39.27
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape8",
    className: "cls-2",
    d: "M153.9,42.16a18.62,18.62,0,1,1-12.19-23.34A18.62,18.62,0,0,1,153.9,42.16Z",
    transform: "translate(-0.66 -0.01)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape9",
    className: "cls-3",
    d: "M185.52,95.85a24.38,24.38,0,1,1-16-30.53A24.4,24.4,0,0,1,185.52,95.85Z",
    transform: "translate(-0.66 -0.01)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape10",
    className: "cls-1",
    d: "M152.8,178.58a39.28,39.28,0,1,1-29.88-4.11A39.27,39.27,0,0,1,152.8,178.58Z",
    transform: "translate(-0.66 -0.01)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval8",
    className: "cls-2",
    cx: 18.63,
    cy: 145.98,
    r: 18.63
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape11",
    className: "cls-3",
    d: "M90.09,170A24.38,24.38,0,1,1,59.5,154.14,24.41,24.41,0,0,1,90.09,170Z",
    transform: "translate(-0.66 -0.01)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuestionmarkGrayscale);
export default __webpack_public_path__ + "static/media/questionmark_grayscale.06716d76473e8c5909b87b050626a123.svg";
export { ForwardRef as ReactComponent };